/* ***************************** ENTITY ***************************** */

export const ENTITY_NUMBER_GEN_ENTITY = "EntityNumberGen"

export const ENTITY_NUMBER_GEN_GROUP_ENTITY = "EntityNumberGenGroup"

/* ****************************** GRID ****************************** */

export const ENTITY_NUMBER_GEN_GROUP_LIST = "entityNumberGenGroupList"

export const ENTITY_NUMBER_GEN_LIST = "entityNumberGenList"



// WEBPACK FOOTER //
// ./src/invoice/constants.ts